import styled from "styled-components";

export const ReactSelectContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: left;

  .react-select {
    width: 100%;
    max-width: 400px;
  }

  .react-select__control {
    height: 60px;
    border-radius: 8px;
    padding: 2px 15px;
  }

  .react-select__single-value {
    font-size: 18px;
    text-transform: uppercase;
  }

  .react-select-blue {
    .react-select__control {
      background-color: rgba(16, 166, 189, 0.06);
      border-color: #10a6bd;
    }

    .react-select__indicator,
    .react-select__single-value {
      color: #10a6bd;
    }
  }
`;
